export default __webpack_public_path__ + "static/media/img-icon-Instagram.389e34ff.svg";